var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9384 22H9.06164C8.47531 22 8 21.5779 8 21.0572V20.75H11.5C11.9142 20.75 12.25 20.4142 12.25 20C12.25 19.5858 11.9142 19.25 11.5 19.25H8V16.75H10C10.4142 16.75 10.75 16.4142 10.75 16C10.75 15.5858 10.4142 15.25 10 15.25H8V12.75H11.5C11.9142 12.75 12.25 12.4142 12.25 12C12.25 11.5858 11.9142 11.25 11.5 11.25H8V8.75H10C10.4142 8.75 10.75 8.41421 10.75 8C10.75 7.58579 10.4142 7.25 10 7.25H8V4.75H11.5C11.9142 4.75 12.25 4.41421 12.25 4C12.25 3.58579 11.9142 3.25 11.5 3.25H8V2.94281C8 2.42211 8.47531 2 9.06164 2H14.9384C15.5247 2 16 2.42211 16 2.94281V21.0572C16 21.5779 15.5247 22 14.9384 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.16ef5ef9b5b09f76bd64ad0ed735dc9f.svg";
export { ForwardRef as ReactComponent };